import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import { filterParams } from "core/util/ParamUtil";
import { User } from "./User";

export interface IOrganizationUserListParams {
	guid: string;
	sort?: string;
	pageSize?: number;
	pageNumber?: number;
}

@Entity({
	one: "organization",
	many: "organizations",
	params: filterParams<IOrganizationUserListParams>(['guid'])
})
export class Organization {

	@Field()
	public id: ID;

	@Field()
	public name: string;

	@Field({entity: User, params: filterParams<IOrganizationUserListParams>(['pageSize', 'sort'])})
	public userList: User[];

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/entities/OrganizationUserList.ts